export class ArcwareLogoLoader {
  public arcwareLogoLoader: HTMLDivElement;

  constructor() {
    this.arcwareLogoLoader = this.createArcwareLogoLoader();
  }

  private createArcwareLogoLoader(): HTMLDivElement {
    const arcwareLogoLoader = document.createElement("div");
    arcwareLogoLoader.classList.add("arcware-logo-loader");
    arcwareLogoLoader.innerHTML = this.getSvg();
    return arcwareLogoLoader;
  }

  private getSvg(): string {
    return `
      <svg width="42" height="80" viewBox="0 0 42 80" xmlns="http://www.w3.org/2000/svg">
        <style>
          @keyframes ripple-1-down {
            0%, 50% { translate: 0 0; }
            60%, 100% { translate: 0 5px; }
          }
          @keyframes ripple-1-up {
            0%, 50% { translate: 0 0; }
            60%, 100% { translate: 0 -5px; }
          }
          @keyframes ripple-2-down {
            0%, 55% { translate: 0 0; }
            65%, 100% { translate: 0 5px; }
          }
          @keyframes ripple-3-down {
            0%, 60% { translate: 0 0; }
            70%, 100% { translate: 0 5px; }
          }
          @keyframes ripple-3-up {
            0%, 60% { translate: 0 0; }
            70%, 100% { translate: 0 -5px; }
          }
          @keyframes ripple-4-up {
            0%, 65% { translate: 0 0; }
            75%, 100% { translate: 0 -5px; }
          }

          .ripple-1-down { animation: ripple-1-down 0.6s infinite alternate; }
          .ripple-1-up   { animation: ripple-1-up 0.6s infinite alternate; }
          .ripple-2-down { animation: ripple-2-down 0.6s infinite alternate; }
          .ripple-3-down { animation: ripple-3-down 0.6s infinite alternate; }
          .ripple-3-up   { animation: ripple-3-up 0.6s infinite alternate; }
          .ripple-4-up   { animation: ripple-4-up 0.6s infinite alternate; }
        </style>

        <g class="ripple-1-down" fill="#f1f1f1">
          <rect y="38" width="6" height="22" />
        </g>
        <g class="ripple-1-up" fill="#f1f1f1">
          <rect y="10" width="6" height="22" />
        </g>
        <g class="ripple-2-down" fill="#f1f1f1">
          <rect x="12" width="6" height="32" />
          <rect x="12" y="38" width="6" height="22" />
        </g>
        <g class="ripple-3-down" fill="#f1f1f1">
          <rect x="24" y="38" width="6" height="22" />
        </g>
        <g class="ripple-3-up" fill="#f1f1f1">
          <rect x="24" y="10" width="6" height="22" />
        </g>
        <g class="ripple-4-up" fill="#f1f1f1">
          <rect x="36" y="10" width="6" height="22" />
          <rect x="36" y="38" width="6" height="32" />
        </g>
      </svg>
    `;
  }
}
